import * as React from "react";
import {Box, Button, OutlinedInput, Stack, Typography} from "@mui/material";
import {useState} from "react";
import {Profile} from "../profile/queries/Profile";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

const ChangePassword = ({setUpdatePasswordMode}) => {
    const [actualPass, setActualPass] = useState('');
    const [newPass, setNewPass] = useState('');
    const [confirmPass, setConfirmPass] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [showPasswordActual, setShowPasswordActual] = React.useState(false);
    const handleClickShowPasswordActual = () => setShowPasswordActual(show => !show);
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword(show => !show);
    const [showPasswordConfirm, setShowPasswordConfirm] = React.useState(false);
    const handleClickShowPasswordConfirm = () =>
        setShowPasswordConfirm(show => !show);

    const checkNewPassword = async () => {
        setIsSuccess(false);
        setError('');
        if (newPass !== confirmPass) {
            setError('La confirmation du nouveau mot de passe n\'est pas valide');
        } else {

            setIsLoading(true);
            const res = await Profile.updatePassword(actualPass, newPass);

            if (res) {
                setIsSuccess(true);
                setIsLoading(false);
                setActualPass('');
                setNewPass('');
                setConfirmPass('');
            } else {
                setError('Mot de passe invalide');
                setIsLoading(false);
                setActualPass('');
                setNewPass('');
                setConfirmPass('');
            }
        }
    }
    const {mode} = useDarkMode();
    return (
        <Box sx={{backgroundColor:mode.settings.cardBackgroundColor, borderRadius:1, padding:'20px'}}>
            <Stack gap={'10px'}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography variant={'subtitle7'} color={mode.settings.textColor3}>Sécurité</Typography>

                </Stack>
                <Typography variant={"body2"} component="span" color={mode.settings.textColor3}>Changer le mot de passe</Typography>
                { !isSuccess &&
                <Stack >
                    <Stack direction={"row"} width={350} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography
                            color={mode.settings.textColor3}
                            component={'label'}
                            id={'label-actualPass'}
                            htmlFor={'actualPass'}
                        >
                            Actuel
                        </Typography>
                        <OutlinedInput
                            size="small"
                            id="actualPass"
                            aria-describedby="label-actualPass"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                            type={showPasswordActual ? 'text' : 'password'}
                            value={actualPass}
                            onChange={event => setActualPass(event.target.value)}
                            style={{height:35, marginBottom:10}}
                            sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3, width: '250px'}}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordActual}
                                        edge="end">
                                        {showPasswordActual ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Stack>
                    <Stack direction={"row"} width={350} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography
                            color={mode.settings.textColor3}
                            component={'label'}
                            id={'label-newPass'}
                            htmlFor={'newPass'}
                        >
                            Nouveau
                        </Typography>
                        <OutlinedInput
                            size="small"
                            id="newPass"
                            aria-describedby="label-newPass"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                            type={showPassword ? 'text' : 'password'}
                            value={newPass}
                            onChange={event => setNewPass(event.target.value)}
                            style={{height:35, marginBottom:10}}
                            sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3, width: '250px'}}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Stack>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Stack direction={"row"} width={350} justifyContent={'space-between'} alignItems={'center'}>
                            <Typography
                                color={mode.settings.textColor3}
                                component={'label'}
                                id={'label-confirmPass'}
                                htmlFor={'confirmPass'}
                            >
                                Confirmer
                            </Typography>
                            <OutlinedInput
                                size="small"
                                id="confirmPass"
                                aria-describedby="label-confirmPass"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                                type={showPasswordConfirm ? 'text' : 'password'}
                                value={confirmPass}
                                onChange={event => setConfirmPass(event.target.value)}
                                style={{height:35, marginBottom:10}}
                                sx={{background :mode.settings.inputBackgroundColor, color:mode.settings.textColor3, width: '250px'}}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPasswordConfirm}
                                            edge="end">
                                            {showPasswordConfirm ? (
                                                <VisibilityOff />
                                            ) : (
                                                <Visibility />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />


                        </Stack>
                        <Button className="btn" onClick={() => checkNewPassword()}>
                            {
                                isLoading ?
                                    <CircularProgress color="inherit" size={30}/>
                                    :
                                    <CheckCircleIcon sx={{mb : '2px'}}/>
                            }
                            <Typography variant={"subtitle3"} component="span">Confirmer</Typography>
                        </Button>
                    </Stack>
                </Stack>}
                {isSuccess && <Typography variant={"error"}>Votre mot de passe a bien été modifié</Typography>}
                <Typography variant={"error"} color={'red'}>{error}</Typography>
            </Stack>
        </Box>
    )
}

export default ChangePassword;
